import React, { useState, useEffect, Fragment, useRef } from 'react';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../Common";
import { IconButton } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { paymentRatesSchema } from "../paymentRatesSchema";
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import '../../Common/Table/table.css';
import MessageModal from '../../../UI/Modal/MessageModal';

import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';


const screenCode = 'PAYMENTRATES'
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function PaymentRates(props) {

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        discription: "Save/ Edit success"
    })

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [collectionCatagory, setCollectionCatagory] = useState([]);
    const [paymentRates, setPaymentRates] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [searchData, setsearchData] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionCategoryID: 0,
        haverstingJobTypeID: 0,
        minRate: '',
        maxRate: '',
        oldMinRate: '',
        oldMaxRate: '',
        isActive: false,
        paymentEnabled: false

    });
    const classes = useStyles();
    const [isTableHidden, setIsTableHidden] = useState(true);
    const [errors, setErrors] = useState({});
    const schema = Joi.object(paymentRatesSchema).options({ allowUnknown: true });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategory(),

        )
    }, [searchData.operationEntityID])

    useEffect(() => {
        trackPromise(
            handleSearch()
        )

    }, [searchData.collectionCategoryID])


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'PAYMENTRATES');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getAllGroups();
    }

    async function getAllGroups() {
        const result = await service.getGroups()
        setGroups(result);
    }

    async function getEstates() {
        var data = await service.getEstatesByGroupID(searchData.groupID);
        setEstates(data);
    }

    async function getCollectionCategory() {
        const result = await service.GetCollectionCategoryByOperationEntityID(searchData.operationEntityID)
        setCollectionCatagory(result);
    }

    async function handleSearch() {
        const result = await service.GetPaymentRates(searchData.collectionCategoryID)
        setPaymentRates(result);

        if (paymentRates.length > 0) {
            setIsTableHidden(false)
        }
        setIsEdit(false);
    }


    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, paymentRatesSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function handleChange1(e) {
        setsearchData({
            ...searchData,
            [e.target.name]: e.target.checked
        });
    }


    function handleRateChange(e) {
        setsearchData({
            ...searchData,
            [e.target.name]: parseFloat(e.target.value)
        });
    }


    const handleEdit = (row) => {
        const array = [...paymentRates]
        const newArray = array.filter((array, i) => i !== row.haverstingJobTypeID);
        setPaymentRates(newArray);
        setsearchData({
            ...searchData,
            haverstingJobTypeID: row.haverstingJobTypeID,
            minRate: row.minRate,
            maxRate: row.maxRate,
            oldMinRate: row.minRate,
            oldMaxRate: row.maxRate
        });
        setIsEdit(true);

    };

    async function update() {
        if ((searchData.minRate < 1) || (searchData.maxRate < 1)) {
            setMessageModel({ ...messageModel, hidden: false, type: 'Error', discription: "Negative Values Are Not Allowed" })
            setTimeout(() => {
                modalDismissHandler();
            }, 1500);
        }
        else {
            const response = await service.updateRates(searchData);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, discription: response.message })
            setTimeout(() => {
                modalDismissHandler();
            }, 2000);
            handleSearch();

        }


    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Payment Rates"
                            />
                        </div>
                        <form>
                            <div className="row row-top-gap">
                                <div className="col-md">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>
                                <div className="col-md">
                                    <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        name="operationEntityID"
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Estate--</MenuItem>
                                        {generateDropDownMenu(estates)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md">
                                    <InputLabel shrink id="collectionCategoryID">Collection Category *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionCategoryID"
                                        name="collectionCategoryID"
                                        value={searchData.collectionCategoryID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection Category--</MenuItem>
                                        {generateDropDownMenu(collectionCatagory)}
                                    </Select>
                                    {errors["collectionCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionCategoryID"]}</FormHelperText>}
                                </div>
                            </div>
                            <br />
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </div>


                            {isEdit ? (
                                <>
                                    <div className="row row-top-gap">
                                        <div className="col-md-4">
                                            <InputLabel shrink id="minRate">Min Rate</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                value={searchData.minRate}
                                                name="minRate"
                                                id="minRate"
                                                onChange={handleRateChange} />
                                            {errors["minRate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["minRate"]}</FormHelperText>}
                                        </div>

                                        <div className="col-md-4">
                                            <InputLabel shrink id="maxRate">Max Rate</InputLabel>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                value={searchData.maxRate}
                                                name="maxRate"
                                                id="maxRate"
                                                onChange={handleRateChange} />
                                            {errors["maxRate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["maxRate"]}</FormHelperText>}
                                        </div>
                                    </div>
                                    {/* <br /> */}

                                    <div className="row row-top-gap">
                                        <div className="col-md-4">

                                            <label htmlFor="switch1">IsActive</label>
                                            <br />
                                            <input
                                                id="isActive"
                                                switch="none"
                                                type="checkbox"
                                                name="isActive"
                                                onChange={(e) => handleChange1(e)}
                                                checked={searchData.isActive}
                                            />
                                            <label
                                                htmlFor="isActive"
                                                data-on-label="Yes"
                                                data-off-label="No"
                                            ></label>
                                        </div>

                                        <div className="col-md-4">
                                            <label htmlFor="switch1">Payment Enabled</label>
                                            <br />
                                            <input
                                                id="paymentEnabled"
                                                switch="none"
                                                type="checkbox"
                                                name="paymentEnabled"
                                                onChange={(e) => handleChange1(e)}
                                                checked={searchData.paymentEnabled}
                                            />
                                            <label
                                                htmlFor="paymentEnabled"
                                                data-on-label="Yes"
                                                data-off-label="No"
                                            ></label>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md pb-1">
                                            <input
                                                type="button"
                                                className="btn btn-primary"
                                                value="Update"
                                                onClick={e => trackPromise(update(e))}
                                            />
                                        </div>
                                    </div>
                                </>)
                                : null}


                            {paymentRates.length > 0 ? (
                                <div hidden={isTableHidden} className="table-responsive row-top-gap">
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Emp Type</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Harvesting Job Type Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Min Rate</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Max Rate</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {paymentRates.map((row, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell component="th" scope="row" align="center">{row.employeeTypeID}</TableCell>
                                                        <TableCell component="th" scope="row" align="center">{row.haverstingJobTypeName}</TableCell>
                                                        <TableCell component="th" scope="row" align="center">{row.minRate}</TableCell>
                                                        <TableCell component="th" scope="row" align="center">{row.maxRate}</TableCell>
                                                        <TableCell align="center">
                                                            <IconButton aria-label="delete" className={classes.margin} onClick={e => handleEdit(row, i)}>
                                                                <EditIcon fontSize="small" />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                                )}

                                            </TableBody>

                                        </Table>
                                    </TableContainer>
                                </div>
                            ) : null}
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.discription}
                clicked={modalDismissHandler}
            />
        </Fragment >
    );
}



